/*
 * @Author: Zhushitao
 * @Date: 2021-07-06 20:35:21
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-10-11 17:00:13
 * @Description: Dynamically insert Linkchat style custom theme
 */
import { inject, observer } from 'mobx-react';
import React, { useEffect, useMemo, useRef } from 'react';

interface IVarCssOptions {
  themes?: Record<string, string>;
}
const DynamicStyles: React.FC<IVarCssOptions> = ({ themes }) => {
  const styleTagRef = useRef<HTMLStyleElement>(document.createElement('style'));
  const cssVar = useMemo(() => {
    let rootVar = '';
    if (themes) {
      const themesArr = Object.keys(themes);
      themesArr.forEach((cssKey) => {
        rootVar = rootVar + `--${cssKey}: ${themes[cssKey]};`;
      });
    }
    return `:root:root{${rootVar}}`;
  }, [themes]);

  useEffect(() => {
    styleTagRef.current.id = 'linkchat-pro-in-styles';
    styleTagRef.current.type = 'text/css';
  }, []);

  useEffect(() => {
    styleTagRef.current.innerText = cssVar;
    document.head.appendChild(styleTagRef.current);
    return () => {
      try {
        styleTagRef.current.innerText = '';
        document.head.removeChild(styleTagRef.current);
      } catch (error) {}
    };
  }, [cssVar]);

  return null;
};

export default inject(({ appContext }) => ({
  themes: appContext.themes,
}))(observer(DynamicStyles));
